import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Při změně cesty odroluje na začátek stránky (SPA jinak zachovává pozici z předchozí stránky). */
export default function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])
  return null
}
